$('select[name="cboUserId"]').change(function () {
    window.location = base_url + 'admin/reporting/studentfeedback/' + $(this).val();
});
